import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';
const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getBranches = async (params = {}) =>
  (await axios.get(`${API_URL}/branch`, { ...withAuth(), params })).data;
export const createBranch = async (data) => (await axios.post(`${API_URL}/branch`, data, withAuth())).data;
export const updateBranch = async (id, data) => (await axios.patch(`${API_URL}/branch/${id}`, data, withAuth())).data;
export const restoreBranch = async (id) => (await axios.patch(`${API_URL}/branch/${id}/restore`, {}, withAuth())).data;
export const deleteBranch = async (id) => (await axios.delete(`${API_URL}/branch/${id}`, withAuth())).data;

export const addUserToBranch = async (data) => (await axios.post(`${API_URL}/branch/${data.branchId}/user/${data.userId}`, data, withAuth())).data;
export const removeUserFromBranch = async (data) => (await axios.delete(`${API_URL}/branch/${data.branchId}/user/${data.userId}`, withAuth())).data;
export const getBranchUsers = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/user`, { ...withAuth(), params })).data;

export const getBranchConfiguration = async (branchId) =>
  (await axios.get(`${API_URL}/branch/${branchId ? `${branchId}/` : ''}configuration`, withAuth())).data;

export const saveBranchConfiguration = async (branchId, payload) => {
  const url = `${API_URL}/branch/${branchId ? `${branchId}/` : ''}configuration`;
  return (await axios[branchId ? 'patch' : 'post'](url, payload, withAuth())).data;
};
